module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dateRangeButtonToggle.customButtonText":"Custom","dateRangeButtonToggle.updateButtonText":"Update","dateRangeButtonToggle.allButtonText":"All","dateRangeButtonToggle.formInvalidText":"Please select a valid date range to continue."}}')
  delete Component.options._Ctor
}
